/**
 * Shared constants for the Preschool Curriculum admin pages (Phase 5).
 *
 * Level codes match the LEVEL_CHOICES in
 * apps/oh_preschool_evaluation/constants/constants.py on the backend.
 */
export const PRESCHOOL_LEVEL_OPTIONS = {
  TODLR: 'Toddler',
  PRENUR: 'Pre-Nursery',
  NUR: 'Nursery',
  LKG: 'LKG'
}

/**
 * Levels that exist in the LO catalog. K2 (UKG) has Annual LOs but no preschool
 * courses or roster yet, so it is kept out of the evaluation/week-builder pickers.
 */
export const PRESCHOOL_CATALOG_LEVEL_OPTIONS = {
  ...PRESCHOOL_LEVEL_OPTIONS,
  UKG: 'K2 / UKG'
}

export const PRESCHOOL_SKILL_TYPE_OPTIONS = {
  spiral: 'Spiral',
  sequential: 'Sequential'
}

/**
 * The sequential strand is called "Literacy" for Nursery (NUR) and K1 (LKG),
 * and "Language" for the younger levels. One global skill; per-level label only.
 */
export const sequentialStrandLabel = (level) =>
  level === 'NUR' || level === 'LKG' ? 'Literacy' : 'Language'

/**
 * Fixed Language (sequential) + Numeric goals for the weekly evaluation.
 * Mirrors the mobile teacher app's evaluationGoals so a weekly eval filled
 * in Alfred has the same shape as one filled on the phone.
 */
export const SEQUENTIAL_FIXED_GOALS = [
  'Recognises letter sounds',
  'Names objects starting with letter sounds',
  'Identifies letters in print',
  'Traces letters'
]
export const sequentialGoalId = (index) => `SEQ_${index + 1}`

export const NUMERIC_FIXED_GOAL_ID = 'NUMERIC_1'
export const NUMERIC_FIXED_GOAL = 'Counts objects and recognises numerals'

export const EVALUATION_OPTIONS = ['Yes', 'No']

// Monthly + term ratings (Beginner / Emerging / Established).
export const MONTHLY_RATING_OPTIONS = [
  { value: 'B', label: 'Beginner' },
  { value: 'E', label: 'Emerging' },
  { value: 'EST', label: 'Established' }
]
export const RATING_LABELS = {
  B: 'Beginner',
  E: 'Emerging',
  EST: 'Established',
  FLAG: 'Needs your call'
}

/**
 * Academic-calendar helper — a thin mirror of the backend services.terms.
 * Academic year runs June→April; May is unmapped. 3 terms: T1 M1–4 (Jun–Sep),
 * T2 M5–8 (Oct–Jan), T3 M9–11 (Feb–Apr). term_key = `${startYear}-T${term}`.
 */
const CALENDAR_TO_SPIRAL = {
  6: 1,
  7: 2,
  8: 3,
  9: 4,
  10: 5,
  11: 6,
  12: 7,
  1: 8,
  2: 9,
  3: 10,
  4: 11
}

export const termKeyForMonthKey = (monthKey) => {
  if (!monthKey || typeof monthKey !== 'string') return null
  const [y, m] = monthKey.split('-').map(Number)
  if (!y || !m) return null
  const spiral = CALENDAR_TO_SPIRAL[m]
  if (!spiral) return null
  const term = spiral <= 4 ? 1 : spiral <= 8 ? 2 : 3
  const startYear = m >= 6 ? y : y - 1
  return `${startYear}-T${term}`
}

export const termLabel = (termKey) => {
  if (!termKey) return ''
  const [start, t] = termKey.split('-T')
  const startYear = Number(start)
  if (!startYear || !t) return termKey
  const nextShort = String((startYear + 1) % 100).padStart(2, '0')
  return `Term ${t}, ${startYear}–${nextShort}`
}
